import axios from "axios";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route as PublicRoute, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../styles/professional-ui.css";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import GroupsWA from "../pages/GroupsWA";
import NewslettersWA from "../pages/NewslettersWA";
import GroupCampaigns from "../pages/GroupCampaigns";
import GroupCampaignShippingReports from "../pages/GroupCampaignShippingReports";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import PublicCodes from "../pages/PublicCodes";
const Storefront = React.lazy(() => import("../pages/Storefront"));
import Connections from "../pages/Connections/";
import SettingsCustom from "../pages/SettingsCustom/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import { ForwardMessageProvider } from "../context/ForwarMessage/ForwardMessageContext";
// import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import Kanban from "../pages/Kanban";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { TicketPopupProvider } from "../context/TicketPopup/TicketPopupProvider";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
//import kanbanSchedules from "../pages/kanbanSchedules/";
import Campaigns from "../pages/Campaigns";
// ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
// import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import CampaignShippingReports from "../pages/CampaignShippingReports";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import ToDoList from "../pages/ToDoList/";
import Subscription from "../pages/Subscription/";
import Files from "../pages/Files/";
import Prompts from "../pages/Prompts";
import QueueIntegration from "../pages/QueueIntegration";
import ForgetPassword from "../pages/ForgetPassWord/"; // Reset PassWd
import VerifyEmail from "../pages/VerifyEmail";
import Privacy from "../pages/Privacy";
import CookieNotice from "../components/CookieNotice";
import HubNotificaMe from "../pages/HubNotificaMe"; // Hub NotificaMe
import DuplicateTicketsManager from "../pages/DuplicateTicketsManager"; // Gestor de Tickets Duplicados
import ReleasesPage from "../pages/ReleasesPage"; // Historial de Versiones
import DBADashboard from "../components/DBADashboard"; // Dashboard DBA
// ✅ ELIMINADO: Performance - Ya no se necesita "Rendimiento CPU", reemplazado por "Rendimiento VPS"
import WhatsAppMetrics from "../pages/WhatsAppMetrics"; // Métricas WhatsApp
import ConnectionsDashboard from "../pages/ConnectionsDashboard"; // Dashboard Conexiones
import VPSPerformance from "../pages/Dashboard/VPSPerformance"; // Dashboard VPS Performance
import FlowBuilders from "../pages/FlowBuilders"; // FlowBuilder - Lista de Flujos
import FlowCampaigns from "../pages/FlowCampaigns"; // FlowCampaigns - Campañas de Flujo
import BusinessOnboarding from "../pages/BusinessOnboarding"; // FASE 6 — Wizard configuración inicial
import AppointmentsPage from "../pages/Appointments"; // FASE 7 — Módulo Agenda
import NegocioPage from "../pages/Negocio";
import Schedules from "../pages/Schedules/";
import StatusCampaigns from "../pages/StatusCampaigns";
import GettingStarted from "../pages/GettingStarted";
import SatisfactionSurveys from "../pages/SatisfactionSurveys";

const AppRoutes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
      <AuthProvider>
	  <ForwardMessageProvider>
        <TicketsContextProvider>
        <TicketPopupProvider>
          <Switch>
            <Route exact path="/login" component={Login} isPrivate={false} />
            <Route exact path="/codigos/:token" component={PublicCodes} isPrivate={false} />
            <Route exact path="/signup" component={Signup} isPrivate={false} />
			<Route exact path="/forgetpsw" component={ForgetPassword} isPrivate={false} />
            <Route exact path="/verify-email" component={VerifyEmail} isPrivate={false} />
            <Route exact path="/privacidad" component={Privacy} isPrivate={false} /> 
            {/* <Route exact path="/create-company" component={Companies} /> */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/getting-started" component={GettingStarted} isPrivate />
                {/* FASE 3.1 / FASE 6: Onboarding solo si el usuario entra a Agenda y aún no hay business_config (ver layout). */}
                <Route exact path="/onboarding" component={BusinessOnboarding} isPrivate />
                <Route exact path="/appointments" component={AppointmentsPage} isPrivate />
                <Route path="/negocio" component={NegocioPage} isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={TicketResponsiveContainer}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/quick-messages"
                  component={QuickMessages}
                  isPrivate
                />
                <Route
                  exact
                  path="/todolist"
                  component={ToDoList}
                  isPrivate
                  />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/groups-wa" component={GroupsWA} isPrivate />
                <Route exact path="/newsletters-wa" component={NewslettersWA} isPrivate />
                <Route exact path="/group-campaigns" component={GroupCampaigns} isPrivate />
                <Route exact path="/group-campaign-shipping-reports" component={GroupCampaignShippingReports} isPrivate />
                <Route exact path="/status-campaigns" component={StatusCampaigns} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/duplicate-tickets" component={DuplicateTicketsManager} isPrivate />
                <Route exact path="/releases" component={ReleasesPage} isPrivate />
                <Route exact path="/dashboard/monitoring" component={DBADashboard} isPrivate />
                {/* ✅ ELIMINADO: Ruta "/dashboard/performance" - Ya no se necesita "Rendimiento CPU" */}
                <Route exact path="/dashboard/whatsapp" component={WhatsAppMetrics} isPrivate />
                <Route exact path="/dashboard/connections" component={ConnectionsDashboard} isPrivate />
                <Route exact path="/dashboard/satisfaction" component={SatisfactionSurveys} isPrivate />
                <Route exact path="/dashboard/vps-performance" component={VPSPerformance} isPrivate />
					{/*<Route exact path="/kanban-schedules" component={kanbanSchedules} isPrivate />*/}
                <Route
                  exact
                  path="/messages-api"
                  component={MessagesAPI}
                  isPrivate
                />
                <Route
                  exact
                  path="/settings/:section?"
                  component={SettingsCustom}
                  isPrivate
                />
				        <Route 
                  exact
                  path="/kanban"
                  component={Kanban}
                  isPrivate
                />
                <Route
                  exact
                  path="/financeiro"
                  component={Financeiro}
                  isPrivate
                />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route
                  exact
                  path="/announcements"
                  component={Annoucements}
                  isPrivate
                />
                <Route
                  exact
                  path="/subscription"
                  component={Subscription}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/flowbuilders" component={FlowBuilders} isPrivate />
                <Route exact path="/flowbuilders/new" component={FlowBuilders} isPrivate />
                <Route exact path="/flowbuilders/:id/edit" component={FlowBuilders} isPrivate />
                <Route exact path="/flowcampaigns" component={FlowCampaigns} isPrivate />
                {showCampaigns && (
                  <>
                    <Route
                      exact
                      path="/contact-lists"
                      component={ContactLists}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/contact-lists/:contactListId/contacts"
                      component={ContactListItems}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns"
                      component={Campaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign/:campaignId/report"
                      component={CampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign-shipping-reports"
                      component={CampaignShippingReports}
                      isPrivate
                    />
                    {/* ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas */}
                    {/* <Route
                      exact
                      path="/campaigns-config"
                      component={CampaignsConfig}
                      isPrivate
                    /> */}
                    {/* Ruta HubNotificaMe */}
                    <Route
                      exact
                      path="/hub-notificame"
                      component={HubNotificaMe}
                      isPrivate
                    />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <CookieNotice />
          <ToastContainer
            autoClose={4000}
            position="top-right"
            newestOnTop
            closeOnClick
            pauseOnFocusLoss={false}
            limit={5}
          />
        </TicketPopupProvider>
        </TicketsContextProvider>
		</ForwardMessageProvider>
      </AuthProvider>
  );
};

const RESERVED_STORE_SLUGS = new Set(["login", "signup", "forgetpsw", "verify-email", "privacidad", "tickets", "negocio", "codigos", "settings", "users", "contacts", "connections", "queues", "tags", "helps", "files", "prompts", "kanban", "financeiro", "subscription", "chats", "flowbuilders", "flowcampaigns", "campaigns", "schedules", "announcements", "dashboard", "getting-started", "onboarding", "appointments", "groups-wa", "newsletters-wa", "group-campaigns", "status-campaigns", "messages-api", "hub-notificame", "releases", "quick-messages", "todolist", "queue-integration", "duplicate-tickets", "public", "api", "assets", "static", "tienda", "admin"]);
const publicBackend = () => String(process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");

function StoreSlugGate() {
  const { storeSlug } = useParams();
  const reserved = RESERVED_STORE_SLUGS.has(String(storeSlug || "").toLowerCase());
  const [state, setState] = useState({ loading: !reserved, companyId: null });
  useEffect(() => {
    if (reserved) return undefined;
    let active = true;
    axios.get(`${publicBackend()}/public/negocio/store-slug/${encodeURIComponent(storeSlug)}`, { timeout: 15000 })
      .then(({ data }) => { if (active) setState({ loading: false, companyId: data?.companyId || null }); })
      .catch(() => { if (active) setState({ loading: false, companyId: null }); });
    return () => { active = false; };
  }, [storeSlug, reserved]);
  if (reserved || (!state.loading && !state.companyId)) return <AppRoutes />;
  if (state.loading) return <div style={{ minHeight: "100vh", background: "#0b0d14", color: "#d3f878", display: "grid", placeItems: "center" }}>Cargando tienda…</div>;
  return <React.Suspense fallback={<div style={{ minHeight: "100vh", background: "#0b0d14", color: "#d3f878", display: "grid", placeItems: "center" }}>Cargando tienda…</div>}><Storefront domainCompanyId={state.companyId} apiOnPageHost={false} /></React.Suspense>;
}

const platformStoreHost = () => {
  const base = String(process.env.REACT_APP_STOREFRONT_BASE_DOMAIN || "").toLowerCase();
  return !!base && window.location.hostname.endsWith(`.${base}`);
};

function DomainStorefront() {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    axios.get("/public/negocio/store-domain", { params: { hostname: window.location.hostname }, timeout: 15000 })
      .then(({ data }) => { if (active) setState({ companyId: data.companyId, loading: false }); })
      .catch(error => { if (active) setState({ loading: false, unavailable: error.response?.status !== 404 }); });
    return () => { active = false; };
  }, []);
  if (state.loading) return <p>Cargando…</p>;
  if (state.unavailable) return <p>No se pudo cargar la tienda. Inténtalo de nuevo en unos minutos.</p>;
  return state.companyId ? <React.Suspense fallback={<p>Cargando tienda…</p>}><Storefront domainCompanyId={state.companyId} /></React.Suspense> : platformStoreHost() ? <main style={{ padding: 40, textAlign: "center" }}><h1>Tienda no encontrada</h1><p>Esta dirección no tiene una tienda activa. Comprueba el nombre o solicita el enlace al vendedor.</p></main> : <AppRoutes />;
}

// Customers do not mount employee sessions, chat sockets, or the administration layout.
const Routes = () => <BrowserRouter><Switch>
  {platformStoreHost() && <PublicRoute component={DomainStorefront} />}
  <PublicRoute exact path="/" component={DomainStorefront} />
  <PublicRoute exact path="/tienda/:companyId" render={() => <React.Suspense fallback={<div style={{ minHeight: "100vh", background: "#0b0d14", color: "#d3f878", display: "grid", placeItems: "center" }}>Cargando tienda…</div>}><Storefront /></React.Suspense>} />
  <PublicRoute exact path="/:storeSlug" component={StoreSlugGate} />
  <PublicRoute component={AppRoutes} />
</Switch></BrowserRouter>;
export default Routes;
